import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["form"];
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/core';
import { SectionSummary } from '../../../domain';
export var FIND_GROUPED_QUESTIONS_BY_SECTION_USE_CASE = 'FIND_GROUP_QUESTIONS_BY_SECTION_USE_CASE';
export var FindGroupQuestionsBySectionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(FindGroupQuestionsBySectionUseCase, _UseCase);

  var _super = _createSuper(FindGroupQuestionsBySectionUseCase);

  function FindGroupQuestionsBySectionUseCase(questionRepository) {
    var _this;

    _classCallCheck(this, FindGroupQuestionsBySectionUseCase);

    _this = _super.call(this);
    _this.questionRepository = questionRepository;
    return _this;
  }

  _createClass(FindGroupQuestionsBySectionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var _groupQuestionsBySect;

        var form, query, groupQuestionsBySections, groupQuestionsBySectionsResponse, sectionSummaries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = input.form, query = _objectWithoutProperties(input, _excluded);
                _context.next = 3;
                return this.questionRepository.findGroupedQuestionsBySection(_objectSpread(_objectSpread({}, query), {}, {
                  formId: form.id.toString()
                }));

              case 3:
                groupQuestionsBySections = _context.sent;

                if (!groupQuestionsBySections.isFailure) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", Result.fail(groupQuestionsBySections.error));

              case 6:
                groupQuestionsBySectionsResponse = groupQuestionsBySections.getValue();
                sectionSummaries = groupQuestionsBySectionsResponse === null || groupQuestionsBySectionsResponse === void 0 ? void 0 : (_groupQuestionsBySect = groupQuestionsBySectionsResponse.sectionSummaries) === null || _groupQuestionsBySect === void 0 ? void 0 : _groupQuestionsBySect.map(function (s) {
                  return SectionSummary.createFromSection(form.sections.find(function (section) {
                    return section.id.toString() === s.id.toString();
                  }));
                });
                return _context.abrupt("return", Result.ok({
                  sectionSummaries: sectionSummaries,
                  questions: groupQuestionsBySectionsResponse.questions
                }));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return FindGroupQuestionsBySectionUseCase;
}(UseCase);